import {
  AppActionTypes,
  SET_NAVIGATION,
  FETCH_CULTURES,
  FETCH_CULTURES_SUCCESS,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_INVOICE_COUNTRIES_SUCCESS,
  FETCH_INTERNATIONAL_PHONE_NUMBER_PREFIXES_SUCCESS,
  FETCH_TITLE_IMAGES_SUCCESS,
  FETCH_TITLE_IMAGES,
  FETCH_CMS_ONETRUST_CONFIGURATION,
  FETCH_CMS_ONETRUST_CONFIGURATION_SUCCESS,
} from './actions';
import { Api, Models } from '@core/types';
import { ApiService } from '@core/services';
import { Dispatch } from 'redux';
import { CookiePopupProps } from '@components/tracking/CookiePopup';

export function setActiveNav(navigation: string): AppActionTypes {
  return {
    type: SET_NAVIGATION,
    payload: navigation,
  };
}

export const fetchCultures = () => async (dispatch: Dispatch) => {
  // Initial action to trigger loaders
  dispatch({
    type: FETCH_CULTURES,
  });

  const response = await ApiService.request<Models.Culture[]>({
    method: Api.Method.GET,
    controller: 'culture',
    slug: 'get-cultures',
    cacheKey: 'all-cultures',
  });

  dispatch({
    type: FETCH_CULTURES_SUCCESS,
    payload: response.data,
  });
};

export const fetchCountries = () => async (dispatch: Dispatch) => {
  const response = await ApiService.request<Models.Country[]>({
    method: Api.Method.GET,
    controller: 'culture',
    slug: 'get-countries',
    cacheKey: 'all-countries',
  });

  dispatch({
    type: FETCH_COUNTRIES_SUCCESS,
    payload: response.data,
  });
};

export const fetchInvoiceCountries = () => async (dispatch: Dispatch) => {
  const response = await ApiService.request<Models.Country[]>({
    method: Api.Method.GET,
    controller: 'culture',
    slug: 'get-invoice-countries',
    cacheKey: 'all-invoice-countries',
  });

  dispatch({
    type: FETCH_INVOICE_COUNTRIES_SUCCESS,
    payload: response.data,
  });
};

export const fetchInternationalPhoneNumberPrefixes = () => async (dispatch: Dispatch) => {
  const response = await ApiService.request<Models.CultureNumber[]>({
    method: Api.Method.GET,
    controller: 'culture',
    slug: 'get-international-phone-number-prefixes',
    cacheKey: 'all-international-phone-number-prefixes',
  });

  dispatch({
    type: FETCH_INTERNATIONAL_PHONE_NUMBER_PREFIXES_SUCCESS,
    payload: response.data,
  });
};

export const fetchTitleImages = () => async (dispatch: Dispatch) => {
  dispatch({
    type: FETCH_TITLE_IMAGES,
  });

  const response = await ApiService.request<Models.TitleImage[]>({
    method: Api.Method.GET,
    controller: 'title-images',
    slug: 'get-title-images',
    cacheKey: 'all-title-images',
  });

  dispatch({
    type: FETCH_TITLE_IMAGES_SUCCESS,
    payload: response.data,
  });
};

export const fetchCmsOneTrustConfiguration = (cultureCode: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: FETCH_CMS_ONETRUST_CONFIGURATION,
    });

    const response = await ApiService.request<CookiePopupProps>({
      baseUrl: process.env.REACT_APP_MAIN_SITE,
      method: Api.Method.POST,
      controller: 'oneTrustConfiguration',
      slug: 'one-trust-configuration',
      params: {
        cultureCode,
      },
      cacheKey: `cms-one-trust-configuration|${cultureCode}`,
    });

    dispatch({
      type: FETCH_CMS_ONETRUST_CONFIGURATION_SUCCESS,
      payload: response,
    });
  };
};
